import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import ReactPlayer from 'react-player'

export default class ReactComponent extends React.Component {

  render () {

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section-header">
            <PortfolioNextPrevLink data={data} />
            <h2>Story</h2>
          </div>
          <p>I have spent two years at Digimagic as a multimedia developer and senior multimedia developer respectively.
          Digimagic is a full-fledged creative agency specialized in customized marketing solutions, experiential media and events.</p>
          <br />
          <p>Here are some of the non-NDA projects I have contributed to.</p>
          <br />

          <h4>Religious Rehabilitation Group (RRG) Gallery, Singapore</h4>
          <p>Wall of Truth Augmented Reality Exhibit</p>
          <ReactPlayer url='https://www.youtube.com/watch?v=2tpDfqCjcfg' controls="true"/>
          <br />

          <h4>Chinese New Year 2014 AR</h4>
          <a className="btn btn-malibu" href="https://www.facebook.com/Digimagicians/videos/633174020079553/">See Facebook Video</a>
          <br /><br />

          <h4>Tesco's A2R, Pattaya, Thailand</h4>
          <ReactPlayer url='https://youtu.be/XAKQ7ID9Nq4?t=19s' controls="true"/>
          <br />

          <h4>Pretronas F1 Aligned AR, Kuala Lumpur, Malaysia</h4>
          <ReactPlayer url='https://youtu.be/XAKQ7ID9Nq4?t=34s' controls="true" />
          <br/>

          <h4>Petronas F1 AR iPad Exhibit, Kuala Lumpur, Malaysia</h4>
          <ReactPlayer url='https://youtu.be/XAKQ7ID9Nq4?t=29s' controls="true"/>
          <br/>

          <h4>Property Report Interactive, Bangkok, Thailand</h4>
          https://itunes.apple.com/us/app/property-report-interactive/id727466347?mt=8
          <br/><br />
          <h4>Hutchinson 3030 Android App, Jakarta, Indonesia</h4>
          <ReactPlayer url='https://www.youtube.com/watch?v=FXzyJkbnjuM' controls="true" />
          <br/>

          <h4>TalkingMumAR, Singapore</h4>
          <ReactPlayer url='https://www.youtube.com/watch?v=_SHw1oSDzLI' controls="true" />
          <br/>

          <h4>O2City, Selangor, Malaysia</h4>
          <ReactPlayer url='https://www.youtube.com/watch?v=QBZTCgcb1ZQ' controls="true" />
          <br/>

          <h4>Brand's Innershine AR App, Singapore</h4>
          https://itunes.apple.com/us/app/my-beauty-secret/id557170186?mt=8
          <br/><br />
          
          <h4>Building and Construction Authority of Singapore</h4>
          <ReactPlayer url='https://www.youtube.com/watch?v=4X7SQ6EDv7E' controls="true" />
          <br/>
          
          <h4>ARCity</h4>
          <p>developed as a demo showcasing 3D tracking using Metaio SDK</p>
          <ReactPlayer url='https://www.youtube.com/watch?v=xnb8OjngVD0' controls="true" />
          
          <br/>
          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
          <br/>

          
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/digimagic-projects/index.js
 **/